import type { Planungsphase, SchwellenwertErgebnis } from './types';

/**
 * Welcher Stand in die Klaerungsliste gedruckt wird.
 *
 * Die Pruefung nach BaustellV (`pruefung`) wird beim Speichern der Grundlagen
 * festgeschrieben. Wer den ungespeicherten Entwurf der Baubeschreibung neben
 * die gespeicherte Pruefung druckt, erzeugt ein Blatt, das es so nie gegeben
 * hat — mit einer Baubeschreibung, zu der die abgedruckte Pruefung nicht
 * passt. Deshalb: bei ungespeicherten Aenderungen wird nicht gedruckt,
 * sondern gesagt, was zu tun ist; sonst kommt alles aus dem gespeicherten
 * Kopfsatz.
 */
export type ExportStand =
    | { status: 'ungespeichert'; hinweis: string }
    | {
        status: 'gespeichert';
        baubeschreibung: string;
        pruefung: SchwellenwertErgebnis | null;
        katalogVersion: number;
    };

export const ERST_SPEICHERN_HINWEIS =
    'Die Grundlagen sind noch nicht gespeichert. Gedruckt und versendet wird nur der gespeicherte Stand — '
    + 'sonst stünde eine geänderte Baubeschreibung neben einer Prüfung, die zu ihr nicht passt. Bitte gleich noch einmal.';

export const ermittleExportStand = (
    phase: Pick<Planungsphase, 'baubeschreibung' | 'pruefung' | 'katalog_version'> | null | undefined,
    schmutzig: boolean,
): ExportStand => {
    if (schmutzig) return { status: 'ungespeichert', hinweis: ERST_SPEICHERN_HINWEIS };
    return {
        status: 'gespeichert',
        baubeschreibung: typeof phase?.baubeschreibung === 'string' ? phase.baubeschreibung : '',
        pruefung: phase?.pruefung || null,
        katalogVersion: typeof phase?.katalog_version === 'number' ? phase.katalog_version : 1,
    };
};
